import type { SVGProps } from 'react';

const SvgAbTesting = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="ab-testing">
      <path d="M11.38.87H3.26A2.75 2.75 0 0 0 .51 3.62v24.76a2.75 2.75 0 0 0 2.75 2.75h8.12a2.75 2.75 0 0 0 2.75-2.75V16.55h3.74v11.83a2.75 2.75 0 0 0 2.75 2.75h8.12a2.75 2.75 0 0 0 2.75-2.75V3.62A2.75 2.75 0 0 0 28.74.87h-8.12a2.75 2.75 0 0 0-2.75 2.75v11.43h-3.74V3.62A2.75 2.75 0 0 0 11.38.87m1.25 27.51a1.25 1.25 0 0 1-1.25 1.25H3.26A1.25 1.25 0 0 1 2 28.38V3.62a1.25 1.25 0 0 1 1.26-1.25h8.12a1.25 1.25 0 0 1 1.25 1.25Zm6.74-24.76a1.25 1.25 0 0 1 1.25-1.25h8.12A1.25 1.25 0 0 1 30 3.62v24.76a1.25 1.25 0 0 1-1.25 1.25h-8.13a1.25 1.25 0 0 1-1.25-1.25Z" />
      <path d="M22.16 5.59h5.04v1.5h-5.04zM22.16 10.32h5.04v1.5h-5.04zM4.8 5.59h5.04v1.5H4.8zM4.8 10.32h5.04v1.5H4.8zM22.16 19.78h5.04v1.5h-5.04zM22.16 15.05h5.04v1.5h-5.04zM22.16 24.51h5.04v1.5h-5.04z" />
    </g>
  </svg>
);

export default SvgAbTesting;
